import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

// Styles
import '../../assets/styles/LandingFooter.css';

const LandingFooter = () => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="landing-footer-container">
      <div className="landing-footer-main-content">

        {/* Navigation Section */}
        <nav className="landing-footer-nav">
          <ul className="landing-footer-nav-list">
            <li><Link to="/terms-and-conditions" className="landing-footer-nav-link">TERMS AND CONDITIONS</Link></li>
            <li><Link to="/privacy-policy" className="landing-footer-nav-link">PRIVACY POLICY</Link></li>
            <li><Link to="/refund-policy" className="landing-footer-nav-link">REFUND POLICY</Link></li>
            <li>
              <a
                href="https://ariseforyou.com"
                className="landing-footer-nav-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                MAIN CONTENT
              </a>
            </li>
          </ul>
        </nav>

      </div>

         {/* Copyright Section */}
<div className="landing-footer-bottom">
  <p className="footer-left">© Copyright {new Date().getFullYear()} ARISE FOR YOU™</p>
  <p className="footer-right">Powered by Digitivity Solutions Private Ltd.</p>
</div>
    </footer>
  );
};

export default LandingFooter;
